import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, MenuItem, Typography } from '@mui/material';
import clsx from 'clsx';
import { useBreakpoints } from 'hooks';

import { ReactComponent as CheckedIcon } from 'assets/icons/CheckedIcon.svg';

import { useBusinessPlanTypeAvailability } from 'hooks/useBusinessPlanTypeAvailability';

import { useEnableSelectTemplateItem } from './hooks/useEnableSelectTemplateItem';
import { ISelectTemplateItemProps } from './types';

import styles from './SelectTemplateItem.module.scss';

export const SelectTemplateItem: React.FC<ISelectTemplateItemProps> = ({
  template,
  label,
  icon,
  color,
  borderColor,
  backgroundColor,
  isSelected,
  onTemplateChange,
  close,
}) => {
  const { t } = useTranslation();

  const { limit } = useBusinessPlanTypeAvailability(template);

  const { isMobile } = useBreakpoints();

  const enableTemplateItem = useEnableSelectTemplateItem(template);

  const handleTemplateChange = () => {
    onTemplateChange(template);
    if (!isMobile) {
      close();
    }
  };

  const cssVariables = {
    '--plan-color': color,
    '--plan-background': backgroundColor,
    '--plan-borderColor': borderColor,
  } as React.CSSProperties;

  return (
    <MenuItem
      key={template}
      className={clsx(styles.menuItem, { [styles.disabled]: !enableTemplateItem() })}
      style={cssVariables}
      onClick={handleTemplateChange}
    >
      <Box className={styles.menuItemBox}>
        <Box className={styles.icon}>{icon}</Box>
        <Box className={styles.title}>{label}</Box>
        <Typography className={clsx(styles.planAvailabilityCount)} variant="body2">
          ({limit} {t('left')})
        </Typography>
      </Box>
      {isSelected && <CheckedIcon />}
    </MenuItem>
  );
};
